import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { get, isEmpty } from "lodash";
import { usePreCheckInContext } from "./contexts/PreCheckInContext";
import BookingService from "../../backend/BookingService";
import { ClipLoaderIcon } from "../../components/LoadingIcon";

const Preferences = ({ match }) => {
  const {
    propertyUid,
    bookingNumber,
    lastName,
    userEmail,
    language,
    data: { accessToken, presets, booking, guests, guestService },
    func: { updateGuests, setAccessTokenData, updateErrorPage },
    components: { PreCheckInContainer },
  } = usePreCheckInContext();

  const history = useHistory();
  const { t } = useTranslation();
  const [isPageMounted, setIsPageMounted] = useState(true);
  const [guestNumber, setGuestNumber] = useState(1);
  const [currentGuest, setCurrentGuest] = useState({});
  const [preferences, setPreferences] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const { guestNumber: matchedGuestNumber } = match.params;
    setGuestNumber(matchedGuestNumber);

    if (guestService && guests && isPageMounted && isEmpty(preferences)) {
      setIsPageMounted(false);
      const currGuest = guests.allGuests()[matchedGuestNumber - 1];
      setCurrentGuest(currGuest);
      setPreferences(currGuest.preferences);
    }
  }, [guestService, guests, isPageMounted, preferences, match]);

  const goContinue = async () => {
    const guestData = {
      ...currentGuest,
      preferences,
    };

    if (!presets.demoMode) {
      setLoading(true);
      window.scrollTo(0, 0);
      await BookingService.putPreferences(
        accessToken,
        propertyUid,
        currentGuest.profileId,
        guestData.preferences
      )
        .then((response) => {
          setLoading(false);
          guests.UpdateByNumber(guestNumber - 1, guestData);
          guests.guests[guestNumber - 1].completed = true;
          updateGuests(guests);
          confirm();
        })
        .catch((error) => {
          setLoading(false);
          if (get(error.response, "status") === 401) {
            setAccessTokenData();
          }
          console.error(error);
          updateErrorPage(true);
        });
    } else {
      guests.guests[guestNumber - 1].completed = true;
      updateGuests(guests);
      confirm();
    }
  };
  const confirm = () => {
    history.push(
      `/pre-checkin/${propertyUid}/book-detail/${bookingNumber}${
        lastName ? `/${encodeURIComponent(lastName)}` : ""
      }?language=${language}${
        userEmail ? `&email=${encodeURIComponent(userEmail)}` : ""
      }`
    );
  };

  const handleCheckboxes = (preferenceValue, checked) => {
    if (preferenceValue) {
      let selectedPreferences = [...preferences];
      selectedPreferences.forEach((preference) => {
        if (preference.preference_value === preferenceValue) {
          preference.selected = checked;
        }
      });
      setPreferences(selectedPreferences);
    }
  };
  return (
    <>
      <PreCheckInContainer containerName="add-yourself-to-trip">
        {presets && booking && (
          <>
            <section
              id="content"
              className="relative flex flex-col px-9 w-full flex-1 md:flex-0 pt-6">
              <div className="flex flex-col h-full">
                <div className="flex mb-10 w-full">
                  <div className="font-normal m-auto">
                    <p
                      className="mb-12 type-normal large text-center justify-center"
                      style={{
                        color: presets.titleColor,
                        whiteSpace: "pre-wrap",
                      }}>
                      {!isEmpty(booking.preference_description)
                        ? booking.preference_description
                        : t(
                            "PLEASE_SELECT_YOUR_PREFERENCE_BELOW",
                            "Please select your preference below"
                          )}
                    </p>
                    <div className="flex flex-col h-full">
                      <ul className="preCheckinSubTitle">
                        {preferences &&
                          preferences.map((preference, index) => (
                            <li
                              key={index}
                              className="mb-5"
                              style={{ background: "none", padding: 0 }}>
                              <div className="inline-flex items-center mb-4">
                                <div className="w-8 mr-4 flex items-center">
                                  <label
                                    htmlFor={preference.preference_value}
                                    className="cursor-pointer">
                                    <input
                                      id={preference.preference_value}
                                      name={preference.preference_value}
                                      onChange={() =>
                                        handleCheckboxes(
                                          preference.preference_value,
                                          preference.selected !== true
                                        )
                                      }
                                      type="checkbox"
                                      value={preference.selected === true}
                                      className="hidden"
                                    />
                                    <svg
                                      role="img"
                                      className={`w-8 h-8 ${
                                        preference.selected === true
                                          ? "hidden"
                                          : "block"
                                      }`}
                                      preserveAspectRatio="xMidYMid meet"
                                      viewBox="0 0 1408 1408">
                                      <path
                                        d="M1120 128H288q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113V288q0-66-47-113t-113-47zm288 160v832q0 119-84.5 203.5T1120 1408H288q-119 0-203.5-84.5T0 1120V288Q0 169 84.5 84.5T288 0h832q119 0 203.5 84.5T1408 288z"
                                        fill={
                                          preference.selected === true
                                            ? "none"
                                            : presets.backgroundColorTopBar
                                        }
                                      />
                                    </svg>
                                    <svg
                                      role="img"
                                      className={`w-8 h-8 ${
                                        preference.selected === true
                                          ? "block"
                                          : "hidden"
                                      }`}
                                      preserveAspectRatio="xMidYMid meet"
                                      viewBox="0 0 1664 1408">
                                      <path
                                        d="M1408 802v318q0 119-84.5 203.5T1120 1408H288q-119 0-203.5-84.5T0 1120V288Q0 169 84.5 84.5T288 0h832q63 0 117 25q15 7 18 23q3 17-9 29l-49 49q-10 10-23 10q-3 0-9-2q-23-6-45-6H288q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113V866q0-13 9-22l64-64q10-10 23-10q6 0 12 3q20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24L281 697q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263l647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"
                                        fill={
                                          preference.selected === true
                                            ? presets.backgroundColorTopBar
                                            : "none"
                                        }
                                      />
                                    </svg>
                                  </label>
                                </div>
                                <div className="break-words subtitle">
                                  <p className="type-regular small leading-7">
                                    <label
                                      className="cursor-pointer"
                                      style={{
                                        color: presets.backgroundColorTopBar,
                                      }}
                                      htmlFor={preference.preference_value}>
                                      {preference.description}
                                    </label>
                                  </p>
                                </div>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <button
                  className={`app-button-ipad type-title medium ${presets.buttonStyleName}`}
                  style={{
                    backgroundColor: presets.backgroundColorTopBar,
                    color: presets.appHomeTextCallToAction,
                  }}
                  onClick={() => goContinue()}>
                  {t("CONTINUE")}
                </button>
              </div>
            </section>
            <button
              className="app-button-mobile type-title medium "
              style={{
                backgroundColor: presets.backgroundColorTopBar,
                color: presets.appHomeTextCallToAction,
                position: "fixed",
                bottom: 0,
                left: 0,
              }}
              onClick={() => goContinue()}>
              {t("CONTINUE")}
            </button>
          </>
        )}
      </PreCheckInContainer>
      {loading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-500 opacity-50 z-50">
          <ClipLoaderIcon
            loadingState={loading}
            size={30}
            color={presets.backgroundColorTopBar}
          />
        </div>
      )}
    </>
  );
};

export default withTranslation()(Preferences);
